enum IOT_DEVICE_TARGET_NAMES {
    DEVICE = 'device',
    DEVICE_ENGINE = 'device_engine',
    HOLDER = 'holder',
    HOLDER_ENGINE = 'holder_engine',
    BLE_STACK = 'ble_stack',
}

export default IOT_DEVICE_TARGET_NAMES;
